import axios from "@/axios-auth";

// Assistente DouraSat no canto esquerdo. Quem decide se aparece é a API
// (docs/superpowers/specs/2026-10-08-chat-ajuda-dourasat-design.md, no backend).
const state = {
  chatAjudaWidget: null,
};

const mutations = {
  setChatAjudaWidget: (state, widget) => {
    state.chatAjudaWidget = widget || null;
  },
};

const getters = {
  chatAjudaWidget: (state) => state.chatAjudaWidget,
};

const actions = {
  buscarWidgetChatAjuda: async ({ commit }) => {
    let widget = null;
    try {
      const res = await axios.get("/chat-ajuda/widget");
      const payload = !res.error && res.data && res.data.success !== false ? res.data.data : null;
      widget = payload && payload.ativo === true && payload.visitor ? payload : null;
    } catch (e) {
      // Recurso opcional: qualquer falha só esconde o assistente.
      widget = null;
    }

    commit("setChatAjudaWidget", widget);

    return widget;
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
